import React from 'react';
import {
  ESTATUS_PROSPECTO_LABELS,
  labelFromMap,
  TEMPERATURA_LABELS,
  TIPO_PROSPECTO_LABELS,
} from '../../services/prospectosCrmService';

const cssSuffix = (value) => String(value || '').toLowerCase().replace(/_/g, '-');

export function ProspectoEstatusBadge({ estatus }) {
  return (
    <span className={`crm-prospectos-badge crm-prospectos-badge--estatus is-${cssSuffix(estatus)}`}>
      {labelFromMap(ESTATUS_PROSPECTO_LABELS, estatus)}
    </span>
  );
}

export function ProspectoTemperaturaBadge({ temperatura }) {
  return (
    <span className={`crm-prospectos-badge crm-prospectos-badge--temperatura is-${cssSuffix(temperatura)}`}>
      {labelFromMap(TEMPERATURA_LABELS, temperatura)}
    </span>
  );
}

export function ProspectoTipoBadge({ tipo }) {
  return (
    <span className={`crm-prospectos-badge crm-prospectos-badge--tipo is-${cssSuffix(tipo)}`}>
      {labelFromMap(TIPO_PROSPECTO_LABELS, tipo)}
    </span>
  );
}

export default ProspectoEstatusBadge;
